// extracted by css-extract-rspack-plugin
var _1 = "character-counter__yfRD7";
var _2 = "description__ratSz";
var _3 = "error__highlight__GLQE9";
var _4 = "extra-info__OrREO";
var _5 = "field__QESYx";
var _6 = "label__giH_Q";
var _7 = "required__nBPYr";
export { _1 as "character-counter", _2 as "description", _3 as "error__highlight", _4 as "extra-info", _5 as "field", _6 as "label", _7 as "required" }
export default { "character-counter": _1, "description": _2, "error__highlight": _3, "extra-info": _4, "field": _5, "label": _6, "required": _7 }
